<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t('herramientas') }}
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-md-4">
            <div class="form-group mb-4" style="color:#1E22AA;font-weight:bold; text-align:left;">
                <label>{{ $t("negocio") }}</label>
                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                    :placeholder="$t('seleccionaNegocio')" @change="cambioNegocio()">
                <el-option v-for="business in listBusinesses" class="select-primary"
                    :value="business.id" :label="business.establishmentName"
                    :key="'BUS' + business.id">
                </el-option>
                </el-select>
            </div>
        </div>
      <div class="col-md-12">
        <div v-if="respuesta && permiso" class="row">
          <!-- Columna Ordenar -->
          <div class="col-md-4">
            <div class="card p-3 ajustes-card">
              <h5 class="mb-3" style="color:#1E22AA;font-weight:bold;">
                <i class="fas fa-sort-alpha-down"></i> {{ $t("ordenar") }}
              </h5>
              <ul class="list-files">
                <li @click="openModalCambiarOrdenProductos()">
                  <span class="opcion-title">{{ $t("ordenarProductosAlfabeticamente") }}</span>
                  <span class="opcion-desc">{{ $t("ordenarProductosAlfabeticamenteDesc") }}</span>
                </li>
                <li @click="openModalCambiarOrdenSubproductos()">
                  <span class="opcion-title">{{ $t("ordenarMateriasPrimasAlfabeticamente") }}</span>
                  <span class="opcion-desc">{{ $t("ordenarMateriasPrimasAlfabeticamenteDesc") }}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- Columna Configurar -->
          <div class="col-md-4">
            <div class="card p-3 ajustes-card">
              <h5 class="mb-3" style="color:#1E22AA;font-weight:bold;">
                <i class="fas fa-cog"></i> {{ $t("configurar") }}
              </h5>
              <ul class="list-files">
                <li @click="openModalCaducidadFacturas()">
                  <span class="opcion-title">{{ $t("configurarFechaCaducidadFacturas") }}</span>
                  <span class="opcion-desc">{{ $t("configurarFechaCaducidadFacturasDesc") }}</span>
                </li>
                <li @click="openModalGuardarImagen()">
                  <span class="opcion-title">{{ $t("configurarLogoFacturas") }}</span>
                  <span class="opcion-desc">{{ $t("configurarLogoNegocioDesc") }}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- Columna Productos -->
          <div class="col-md-4">
            <div class="card p-3 ajustes-card">
              <h5 class="mb-3" style="color:#1E22AA;font-weight:bold;">
                <i class="fas fa-box"></i> {{ $t("productos") }}
              </h5>
              <ul class="list-files">
                <li @click="openModalCambiarPrecioProducto()">
                  <span class="opcion-title">{{ $t("cambiarPreciosAProductos") }}</span>
                  <span class="opcion-desc">{{ $t("cambiarPreciosAProductosDesc") }}</span>
                </li>
                <li @click="openModalCalcularCostoProductos()">
                  <span class="opcion-title">{{ $t("calcularCostoProductos") }}</span>
                  <span class="opcion-desc">{{ $t("calcularCostoProductosDesc") }}</span>
                </li>
                <li @click="goToGestionHerramientas()">
                  <span class="opcion-title">{{ $t("gestionAvanzadaHerramientas") }}</span>
                  <span class="opcion-desc">{{ $t("gestionAvanzadaHerramientasDesc") }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    


                        <!--<template v-if="!permiso">
                            <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                                Lo sentimos. Este negocio no cuenta con este módulo activado.
                            </div>
                        </template>-->

                        <!-- <template v-if="herramienta === 0 && respuesta && permiso">

                            <div class="col-md-12">
                                <p class="wrapperTitleImpresion">{{ $t("categoria") }}</p>
                            </div>
                            <div class="col-md-12">

                                <div class="form-group">
                                    <label><strong>{{ $t("categoria") }}</strong></label>
                                    <el-select class="select-default" size="large" v-model="idCategoryModal" filterable
                                        multiple>
                                        <el-option v-for="category in listCategoryModal" class="select-primary"
                                            :value="category.value" :label="category.label"
                                            :key="'CTGRY' + category.label">
                                        </el-option>
                                    </el-select>
                                </div>

                            </div>
                            <div class="col-md-12">
                                <p class="wrapperTitleImpresion">{{ $t("impresoraComanda") }}</p>
                            </div>
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label><strong>{{ $t("impresoraComandaTpv") }}</strong></label>

                                    <el-select class="select-default" size="large" v-model="impresora.idPrinterTpv"
                                        filterable :placeholder="$t('seleccionaNegocio')">
                                        <el-option v-for="printer in listPrinter" class="select-primary"
                                            :value="printer.name" :label="printer.name" :key="'PRNR' + printer.name">
                                        </el-option>
                                    </el-select>
                                </div>

                            </div>
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label><strong>{{ $t("impresoraComandaPda") }}</strong></label>

                                    <el-select class="select-default" size="large" v-model="impresora.idPrinterPDA"
                                        filterable :placeholder="$t('seleccionaNegocio')">
                                        <el-option v-for="printer in listPrinter" class="select-primary"
                                            :value="printer.name" :label="printer.name" :key="'PRNTR' + printer.name">
                                        </el-option>
                                    </el-select>
                                </div>


                            </div>
                            <div class="col-md-12">
                                <p class="wrapperTitleImpresion">{{ $t("copiaImpresionDeComanda") }}</p>
                            </div>
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label><strong>{{ $t("copiaImpresoraComandasTpv") }}</strong></label>

                                    <el-select class="select-default" size="large" v-model="impresora.idPrinterCopiaTpv"
                                        filterable :placeholder="$t('seleccionaNegocio')">
                                        <el-option v-for="printer in listPrinter" class="select-primary"
                                            :value="printer.name" :label="printer.name" :key="'PRINTR' + printer.name">
                                        </el-option>
                                    </el-select>
                                </div>

                            </div>
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label><strong>{{ $t("copiaImpresoraComandasPda") }}</strong></label>

                                    <el-select class="select-default" size="large" v-model="impresora.idPrinterCopiaPDA"
                                        filterable :placeholder="$t('seleccionaNegocio')">
                                        <el-option v-for="printer in listPrinter" class="select-primary"
                                            :value="printer.name" :label="printer.name" :key="'IMPRES' + printer.name">
                                        </el-option>
                                    </el-select>
                                </div>


                            </div>
                            <div class="col-md-6">

                                <p class="wrapperTitleImpresion">{{ $t("impresionPorPlano") }}</p>


                                <div class="form-group">
                                    <label><strong>{{ $t("impresionPlano1") }}</strong></label>

                                    <el-select class="select-default" size="large" v-model="impresora.idPrinterPlano1"
                                        filterable :placeholder="$t('seleccionaNegocio')">
                                        <el-option v-for="printer in listPrinter" class="select-primary"
                                            :value="printer.name" :label="printer.name" :key="'IMPR' + printer.name">
                                        </el-option>
                                    </el-select>


                                </div>

                                <div class="form-group">
                                    <label><strong>{{ $t("impresionPlano2") }}</strong></label>

                                    <el-select class="select-default" size="large" v-model="impresora.idPrinterPlano2"
                                        filterable :placeholder="$t('seleccionaNegocio')">
                                        <el-option v-for="printer in listPrinter" class="select-primary"
                                            :value="printer.name" :label="printer.name" :key="'P' + printer.name">
                                        </el-option>
                                    </el-select>
                                </div>


                                <div class="form-group">
                                    <label><strong>{{ $t("impresionPlano3") }}</strong></label>

                                    <el-select class="select-default" size="large" v-model="impresora.idPrinterPlano3"
                                        filterable :placeholder="$t('seleccionaNegocio')">
                                        <el-option v-for="printer in listPrinter" class="select-primary"
                                            :value="printer.name" :label="printer.name" :key="'PR' + printer.name">
                                        </el-option>
                                    </el-select>
                                </div>

                            </div>
                            <div class="col-md-6">

                                <p class="wrapperTitleImpresion">{{ $t("monitorDeCocina") }}</p>

                                <div class="form-group">
                                    <label><strong>{{ $t("enviarComandaDesdeTpv") }}</strong></label>

                                    <el-select class="select-default" size="large" v-model="impresora.idPrinterKDSTPV"
                                        filterable :placeholder="$t('seleccionaNegocio')">
                                        <el-option v-for="printer in listKds" class="select-primary"
                                            :value="printer.name" :label="printer.name" :key="'PRINTER' + printer.name">
                                        </el-option>
                                    </el-select>
                                </div>


                                <div class="form-group">
                                    <label><strong>{{ $t("enviarComandaDesdePda") }}</strong></label>

                                    <el-select class="select-default" size="large" v-model="impresora.idPrinterKDSPDA"
                                        filterable :placeholder="$t('seleccionaNegocio')">
                                        <el-option v-for="printer in listKds" class="select-primary"
                                            :value="printer.name" :label="printer.name" :key="'PRINT' + printer.name">
                                        </el-option>
                                    </el-select>
                                </div>


                            </div>
                            <div align="right" class="col-12">
                                <el-checkbox v-model="impresora.checked">{{ $t('asignarImpresorasSeleccionadasEnBlanco')
                                    }}
                                </el-checkbox>
                                <button @click="impresionGrupo()" class="btn btn-primary"><i
                                        class="fas fa-exchange-alt"></i>
                                    {{ $t('aplicarCambios') }}
                                </button>
                            </div>

                        </template> -->

                    </div>
                    <modal name="modal-ordenar-productos" :adaptive=true :scrollable=true height="auto"
                        :clickToClose=true class="modal-right">
                        <div>
                            <div class="modal-header wrapperTitle">
                                <h4 style="margin: 0px">{{ $t('ordenarAlfabeticamenteProductos') }}</h4>
                                <span class="close-btn" @click="resetModal()">&times;</span>

                            </div>
                            <div class="modal-body">

                                <div class="row">

                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>{{ $t("categoria") }}</label>
                                            <el-select class="select-default" size="large" v-model="idCategoryModal"
                                                filterable multiple :placeholder="$t('seleccionarNegocio')">
                                                <el-option v-for="category in listCategoryModal" class="select-primary"
                                                    :value="category.value" :label="category.label"
                                                    :key="'CATER' + category.value">
                                                </el-option>
                                            </el-select>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div class="modal-footer">
                                <div align="right" class="col-12">
                                    <button @click="changeOrdenAlfabeticamenteProductos()" class="btn btn-primary">
                                        <i class="fas fa-sort-alpha-down"></i> {{ $t('ordenar') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </modal>
                    <modal name="modal-ordenar-subproductos" :adaptive=true :scrollable=true height="auto"
                        :clickToClose=true class="modal-right">
                        <div>
                            <div class="modal-header wrapperTitle">
                                <h4 style="margin: 0px">{{ $t('ordenarAlfabeticamenteSubproductos') }}</h4>
                                <span class="close-btn" @click="resetModal()">&times;</span>

                            </div>
                            <div class="modal-body">

                                <div class="row">

                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>{{ $t("categoria") }}</label>
                                            <el-select class="select-default" size="large" v-model="idCategoryModal"
                                                filterable multiple :placeholder="$t('seleccionaNegocio')">
                                                <el-option v-for="category in listCategoryModal" class="select-primary"
                                                    :value="category.value" :label="category.label"
                                                    :key="'CATE' + category.value">
                                                </el-option>
                                            </el-select>
                                        </div>

                                    </div>

                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>{{$t("tipo")}} <span class="text-danger">*</span></label>
                                            <el-select class="select-default" size="large" v-model="idCategoryModal3"
                                                filterable multiple :placeholder="$t('seleccioneElTipo')">
                                                <el-option class="select-primary" value="B" label="Base" key="B">
                                                </el-option>
                                                <el-option class="select-primary" value="O" label="Opcionales" key="O">
                                                </el-option>
                                                <el-option class="select-primary" value="E" label="Extra" key="E">
                                                </el-option>
                                            </el-select>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div class="modal-footer">
                                <div align="right" class="col-12">
                                    <button @click="changeOrdenAlfabeticamenteSubproductos()" class="btn btn-primary">
                                        <i class="fas fa-sort-alpha-down"></i> {{ $t('ordenar') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </modal>


                    <modal name="modalCambiarPrecio" :adaptive=true :scrollable=true height="auto" :clickToClose=true class="modal-right">
                        <div>
                            <div class="modal-header wrapperTitle">
                                <h4 style="margin: 0px">{{ $t("cambioDePrecioProductos") }}</h4>
                                <span class="close-btn" @click="resetModal()">&times;</span>

                            </div>
                            <div class="modal-body">

                                <div class="row">


                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>{{ $t("categoria") }}</label>
                                            <el-select class="select-default" size="large" v-model="idCategoryModal"
                                                filterable multiple :placeholder="$t('seleccionaNegocio')">
                                                <el-option v-for="category in listCategoryModal" class="select-primary"
                                                    :value="category.value" :label="category.label"
                                                    :key="'CAT' + category.value">
                                                </el-option>
                                            </el-select>
                                        </div>

                                    </div>


                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>{{ $t("opcion") }}</label>

                                            <el-select class="select-default" size="large" v-model="idVariable"
                                                filterable :placeholder="$t('seleccionaNegocio')">
                                                <el-option v-for="variacion in listVariables" class="select-primary"
                                                    :value="variacion.value" :label="variacion.label"
                                                    :key="'VAR' + variacion.value">
                                                </el-option>
                                            </el-select>
                                        </div>

                                    </div>


                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>{{ $t("tipoDeTarifa") }}</label>

                                            <el-select class="select-default" size="large" v-model="idTarifa" filterable
                                                :placeholder="$t('seleccionaNegocio')">
                                                <el-option v-for="tarifa in listTarifas" class="select-primary"
                                                    :value="tarifa.value" :label="tarifa.label"
                                                    :key="'TF' + tarifa.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>

                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <vue-numeric currency="€" inputmode="decimal" type="text"
                                                class="form-control" currency-symbol-position="suffix" :precision="2"
                                                v-model="precio"
                                                @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                                        </div>
                                    </div>


                                </div>
                            </div>

                            <div class="modal-footer">
                                <div align="right" class="col-12">
                                    <button v-once-click.once="changePrice" class="btn btn-primary"><i
                                            class="fa fa-exchange"></i>
                                        {{ $t("cambiarPrecio") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </modal>
                    <modal name="modal-caducidad-facturas" :adaptive=true :scrollable=true height="auto"
                        :clickToClose=true class="modal-right">
                        <div>
                            <div class="modal-header wrapperTitle">
                                <h4 style="margin: 0px">{{$t("configurarFechaDeVencimientoDeFacturas")}}</h4>
                                <span class="close-btn" @click="resetModal()">&times;</span>
                            </div>
                            <div class="modal-body">

                                <div class="row">
                                    <div class="col-12">
                                        <p>{{$t("datoInformativo")}}</p>
                                        <p>{{$t("introduzcaElNumeroDeDiasEnElQueVenceranLasFacturas")}}</p>                                        
                                        <el-input-number v-model="diasCaducidadFacturas" :min="0"></el-input-number>
                                    </div>
                                </div>

                            </div>

                            <div class="modal-footer">
                                <div align="right" class="col-12">
                                    <button @click="guardarCambiosCaducidadFacturas()" class="btn btn-primary"><i
                                            class="fa fa-check"></i>
                                        {{$t("guardar")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </modal>
                    <modal name="modal-calcular-costo" :adaptive=true :scrollable=true height="auto" :clickToClose=true class="modal-right">
                        <div>
                            <div class="modal-header wrapperTitle">
                                <h4 style="margin: 0px">{{$t("calcularCostoDeTodosLosProductos")}}</h4>
                                <span class="close-btn" @click="resetModal()">&times;</span>
                            </div>
                            <div class="modal-body">
                                <div class="row">

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="listTPV"><strong>{{ $t("TPV") }}</strong></label>

                                            <el-select class="select-default" size="large" v-model="idTpv"
                                                v-on:change="cambiarTpv()" filterable
                                                :placeholder="$t('seleccionaTpv')">
                                                <el-option v-for="tpv in listTpv" class="select-primary" :value="tpv.id"
                                                    :label="tpv.nameShow" :key="'TPV' + tpv.id">
                                                </el-option>
                                            </el-select>

                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <el-checkbox v-model="conIva">Con IVA</el-checkbox>
                                        <el-checkbox v-model="sinIva">Sin IVA</el-checkbox>
                                    </div>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <div align="right" class="col-12">
                                    <button v-once-click.once="calcularCostos" class="btn btn-primary"><i
                                            class="fa fa-check"></i>
                                        {{ $t("calcular") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </modal>

                    <modal name="modal-cargar-imagen" :adaptive="true" :scrollable="true" height="auto"
                        :clickToClose="false" @opened="openImageModal" class="modal-right">
                        <div class="modal-content">

                            <div class="modal-header wrapperTitle">

                                <h4 style="margin: 0px">{{ $t("configurarLogoNegocio") }}</h4>
                                <span class="close-btn" @click="resetModal()">&times;</span>


                            </div>

                            <div class="modal-body">

                                <div class="row">
                                    <div class="col-md-12 mt-4">
                                        <div class="alert alert-info text-center small p-3">
                                            <p class="mb-0">{{ $t("restriccionesLogo") }}</p>
                                            <strong>{{ $t("tamañoMaximo") }}:</strong> {{ maxSize }} KB /
                                            <strong>{{ $t("dimensionesMaximas") }}:</strong> {{ maxWidth }} x {{
                                                maxHeight }} px.
                                        </div>

                                    </div>
                                    <div v-if="imageUrl" class="col-md-12 image-preview-container text-center mt-4">

                                        <div class="image-wrapper">
                                            <img :src="imageUrl" alt="Imagen seleccionada"
                                                class="img-fluid preview-image border rounded shadow-lg"
                                                style="max-width: 100%; height: auto;" />
                                            <div v-if="imageInfo" class="image-info small mt-3">
                                                <strong>{{ $t("tamaño") }}</strong> {{ imageInfo.size }}
                                                KB /
                                                <strong>{{ $t("dimensiones") }}</strong> {{
                                                imageInfo.width }} x {{
                                                imageInfo.height }} px.
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else id="error-message" class=" mt-3 mb-4">
                                        <p> {{ $t("noExisteLogoNegocio") }}</p>
                                    </div>
                                    <div class="col-md-12 mt-4">
                                        <div class="form-group text-center">
                                            <label for="file-upload"
                                                class="label-upload font-weight-bold d-block mb-2"></label>
                                            <div class="custom-file-upload">
                                                <input type="file" id="file-upload"
                                                    @change="manageImageActions(null, $event)" class="file-upload-input"
                                                    accept="image/*" />
                                                <label for="file-upload" class="btn btn-outline-primary custom-btn">{{
                                                    $t("seleccionLogo")
                                                    }}</label>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>

                            <div v-if="showButtons" class="modal-footer d-flex mb-2">
                                <div class="d-flex">
                                    <button @click="openImageModal()" class="btn btn-secundary">
                                        <i class="fas  fa-times-circle"></i> {{ $t("botonCancelar") }}
                                    </button>
                                </div>
                                <div class="d-flex">
                                    <button @click="showReplaceConfirmation()" class="btn btn-primary">
                                        <i class="fas fa-save"></i> {{ $t("botonGuardar") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </modal>

                </div>
            
</template>

<script>
import swal from 'sweetalert2'

import { Loading } from 'element-ui';
import {
    DatePicker,
    Select,
    Option,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Button,
    Checkbox,
    Switch,
    CheckboxButton,
    Transfer,
    ButtonGroup,
    Steps,
    Step
} from 'element-ui'
import { mapState } from 'vuex'

export default {
    created() {
        this.$store.dispatch("setNameRoute", this.$i18n.t("herramientas"));
        this.getBusiness();

        this.loadingGeneral = Loading.service({ text: this.$t('cargando') });


        if (this.$store.getters.idBusiness) {
            this.idBusiness = this.$store.getters.idBusiness;
        }
    },

    updated() {

        this.nPeticiones++;

        if (this.nPeticiones === 2) {
            this.loadingGeneral.close();
        }


    },

    data() {
        return {

            nPeticiones: 0,
            loadingGeneral: null,

            data2: [],
            value2: [],
            filterMethod(query, item) {
                return item.initial.toLowerCase().indexOf(query.toLowerCase()) > -1;
            },
            loading: false,
            listBusinesses: [],
            idBusiness: this.$route.params.idBusiness,
            listCategory: [],
            listCategoryModal: [],
            idCategory1: 0,
            idCategory2: 0,
            idCategoryModal: [],
            idCategoryModal2: [],
            idCategoryModal3: [],
            listPrinter: [],
            respuesta: true,
            action: this.$t('cambiarImpresorasAProductos'),
            listKds: [],
            listTpv: [],
            //HERRAMIENTAS
            //1-Cambiar impresion grupo
            //2-Transferir producto de una categoria a otra
            //3-Cambiar precios a productos
            herramienta: 0,

            //CAMBIO PRECIO

            listVariables: [{ label: this.$t("igualar"), value: 1 }, { label: this.$t('sumar'), value: 2 }, {
                label: this.$t('restar'),
                value: 3
            }, { label: this.$t('multiplicar'), value: 4 }],
            idVariable: 1,
            listTarifas: [{ label: this.$t('todasLasTarifas'), value: 0 }, { label: this.$t('tarifa1'), value: 1 }, {
                label: this.$t('tarifa2'),
                value: 2
            }, { label: this.$t('tarifa3'), value: 3 }, { label: this.$t('tarifa4'), value: 4 }],
            idTarifa: 0,
            precio: 0,
            idTpv: 0,
            sinIva: false,
            conIva: false,
            //PRINTERS IDS
            diasCaducidadFacturas: 0,
            impresora: {
                checked: false,
                idPrinterTpv: this.$t('ningunaSeleccionada'),
                idPrinterPDA: this.$t('ningunaSeleccionada'),
                idPrinterCopiaTpv: this.$t('ningunaSeleccionada'),
                idPrinterCopiaPDA: this.$t('ningunaSeleccionada'),
                idPrinterPlano1: this.$t('ningunaSeleccionada'),
                idPrinterPlano2: this.$t('ningunaSeleccionada'),
                idPrinterPlano3: this.$t('ningunaSeleccionada'),
                idPrinterKDSTPV: this.$t('ningunaSeleccionada'),
                idPrinterKDSPDA: this.$t('ningunaSeleccionada')
            },

            //Logo.
            image: null,
            imageUrl: null,
            imageFile: null,
            imageInfo: null,
            showButtons: false,
            validTypes: ['image/jpeg', 'image/png', 'image/gif'], 
            maxSize: 5 * 1024, // 5120 KB.
            maxWidth: 2000,
            maxHeight: 2000, 
            minWidth: 100, 
            minHeight: 100, 
        };
    },


    methods: {
        /*openModalCambiarProducto() {

            this.getProductsByCategory();
            this.$modal.show('modalcambiarProduct');

        },
        */

       positionModalRight(modalName) {
            this.$nextTick(() => {
            const card = this.$el.querySelector('.ajustes-card');
            // Selecciona el modal globalmente
            const modal = document.querySelector('.vm--modal');
            if (card && modal) {
                const rect = card.getBoundingClientRect();
                // Elimina los estilos que lo centran
                modal.style.left = `${rect.right + 24}px`;
                modal.style.top = `${rect.top}px`;
                modal.style.right = 'auto';
                modal.style.bottom = 'auto';
                modal.style.margin = '0';
                modal.style.transform = 'none';
                modal.style.position = 'fixed';
                modal.style.zIndex = '9999';
                modal.style.width = '500px';
                modal.style.maxWidth = '90vw';
            }
            });
        },
         openModalCambiarPrecioProducto() {
            this.$modal.show('modalCambiarPrecio');
            this.positionModalRight('modalCambiarPrecio');
        },
        openModalCambiarOrdenProductos() {
            this.$modal.show('modal-ordenar-productos');
            this.positionModalRight('modal-ordenar-productos');
        },
        openModalCambiarOrdenSubproductos() {
            this.$modal.show('modal-ordenar-subproductos');
            this.positionModalRight('modal-ordenar-subproductos');
        },
        openModalCalcularCostoProductos() {
            this.getTpv();
            this.conIva = false;
            this.sinIva = false;
            this.$modal.show('modal-calcular-costo');
            this.positionModalRight('modal-calcular-costo');
        },
        openModalCaducidadFacturas() {
            this.getCaducidadFacturas();
            this.positionModalRight('modal-caducidad-facturas');
        },
        openModalGuardarImagen() {
            this.$modal.show('modal-cargar-imagen');
            this.positionModalRight('modal-cargar-imagen');
        },
        resetModal() {
            this.$modal.hide('modal-cargar-imagen');
            this.$modal.hide('modal-calcular-costo');
            this.$modal.hide('modal-ordenar-subproductos');
            this.$modal.hide('modal-ordenar-productos');
            this.$modal.hide('modalCambiarPrecio');
            this.$modal.hide('modal-caducidad-facturas');
            this.closeModal();
        },
        getCaducidadFacturas() {
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    numConfig: 110,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios
                .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.diasCaducidadFacturas = response.data.result;
                    } else {
                        vm.diasCaducidadFacturas = 0;
                    }

                    vm.$modal.show('modal-caducidad-facturas');
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {

                    if (!vm.idBusiness) {
                        vm.idBusiness = response.data.result[0].id;
                    }

                    vm.listBusinesses = response.data.result;
                    vm.getCategory();
                    vm.getPrinterByBusiness();

                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        //Cargo todos los tpvs del idBusiness

        getTpv() {
            this.listTpv = [];
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {

                        vm.idTpv = response.data.result[0].id;

                        for (let i = 0; i < response.data.result.length; i++) {

                            let printername = {
                                nameShow: response.data.result[i].nameShow,
                                id: response.data.result[i].id
                            };

                            vm.listTpv.push(printername);
                        }
                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

        },

        calcularCostos() {
            if (this.conIva) {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };
                var params = {
                    idTpv: this.idTpv,
                    sinIva: false,
                    jwt: this.$store.getters.jwt
                };

                let vm = this;
                this.axios.post(this.$store.getters.apiUrl + "products/calculateProductsCosts", params, config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.$notify({
                                message: 'Costes actualizados',
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.$modal.hide('modal-calcular-costo');

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }

            if (this.sinIva) {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };
                var params = {
                    idTpv: this.idTpv,
                    sinIva: true,
                    jwt: this.$store.getters.jwt
                };

                let vm = this;
                this.axios.post(this.$store.getters.apiUrl + "products/calculateProductsCosts", params, config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.$notify({
                                message: 'Costes actualizados',
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.$modal.hide('modal-calcular-costo');

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
        guardarCambiosCaducidadFacturas() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            var params = {
                idBusiness: this.idBusiness,
                dias: this.diasCaducidadFacturas,
                jwt: this.$store.getters.jwt
            };

            let vm = this;
            this.axios.post(this.$store.getters.apiUrl + "general/updateCaducidadFacturas", params, config)
                .then(function (response) {
                    if (response.data.response) {

                        vm.$notify({
                            message: 'Caducidad actualizada',
                            icon: 'nc-icon nc-check-2',
                            timeout: 2000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        });

                        vm.$modal.hide('modal-caducidad-facturas');

                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        cambioNegocio() {

            this.getCategory();
            this.idCategoryModal = [];
            this.idCategoryModal2 = [];
            this.getPrinterByBusiness();
            this.listPrinter = [];
            this.listKds = [];
        },

        getCategory() {
            this.listCategory = [];
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'categories/getCategoryGeneralesByBusinesses', config)
                .then(function (response) {
                    if (response.data.response) {


                        vm.idCategoryModal.push(response.data.result[0].id);
                        vm.idCategoryModal2.push(response.data.result[1].id);
                        vm.idCategory1 = response.data.result[0].id;
                        vm.idCategory2 = response.data.result[1].id;

                        for (let i = 0; i < response.data.result.length; i++) {

                            if (response.data.result[i].id !== 0) {

                                vm.listCategoryModal.push({
                                    label: response.data.result[i].name,
                                    value: response.data.result[i].id

                                })
                            }


                            let categoryname = {
                                name: response.data.result[i].name,
                                id: response.data.result[i].id,
                                code: response.data.result[i].code
                            };

                            vm.listCategory.push(categoryname)
                        }

                        vm.respuesta = true;

                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        vm.respuesta = false;
                    }

                });
        },

        //CAMBIAR IMPRESORAS
        impresionGrupo() {
            this.$modal.hide('modalCambiarImpresora');

            if (this.idCategoryModal.length !== 0) {

                var controller = "changePrinterByCategoryGeneral";

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };
                var params = {
                    impresora: this.impresora,
                    idCategory: this.idCategoryModal,
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                };

                let vm = this;

                this.axios.post(this.$store.getters.apiUrl + 'categories/' + controller, params, config)
                    .then(function (response) {
                        if (response.data.response) {


                            vm.$notify({
                                message: vm.$t('impresionDeProductosEfectuadaCorrectamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });


                        } else {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            } else {

                swal({
                    title: this.$t('atencion'),
                    text: this.$t('tienesQueSeleccionarUnaCategoria'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            }
        },
        getPrinterByBusiness() {
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'printer/getPrintersByBusinesses', config)
                .then(function (response) {
                    if (response.data.response) {
                        let printer = {
                            name: vm.$t('ningunaSeleccionada'),
                            id: 0
                        };

                        vm.listPrinter.push(printer);

                        for (let i = 0; i < response.data.result.impresoras.length; i++) {
                            let printername = {
                                name: response.data.result.impresoras[i]
                            };

                            vm.listPrinter.push(printername)
                        }

                        vm.listKds.push(printer);

                        for (let i = 0; i < response.data.result.kds.length; i++) {
                            let printername = {
                                name: response.data.result.kds[i]
                            };

                            vm.listKds.push(printername)
                        }

                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });

        },

        //CAMBIAR PRECIO
        changePrice() {


            this.$modal.hide('modalCambiarPrecio');

            var controller = "changePriceByCategoryGeneral";

            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            var params = {
                idVariable: this.idVariable,
                idTarifa: this.idTarifa,
                idCategory: this.idCategoryModal,
                precio: this.precio,
                idBusiness: this.idBusiness,
                jwt: this.$store.getters.jwt
            };

            let vm = this;

            this.axios.post(this.$store.getters.apiUrl + 'categories/' + controller, params, config)
                .then(function (response) {
                    if (response.data.response) {


                        vm.$notify({
                            message: vm.$t('transferenciaDeProductosEfectuadaCorrectamente'),
                            icon: 'nc-icon nc-check-2',
                            timeout: 2000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        });


                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });

        },

        changeOrdenAlfabeticamenteProductos() {


            this.$modal.hide('modal-ordenar-productos');

            var controller = "changeOrdenAlfabeticoByProducts";

            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            var params = {
                idCategory: this.idCategoryModal,
                idBusiness: this.idBusiness,
                jwt: this.$store.getters.jwt
            };

            let vm = this;

            this.axios.post(this.$store.getters.apiUrl + 'categories/' + controller, params, config)
                .then(function (response) {
                    if (response.data.response) {


                        vm.$notify({
                            message: vm.$t('transferenciaDeProductosEfectuadaCorrectamente'),
                            icon: 'nc-icon nc-check-2',
                            timeout: 2000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        });

                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });


        },

        changeOrdenAlfabeticamenteSubproductos() {

            if (this.idCategoryModal3.length > 0) {

                this.$modal.hide('modal-ordenar-subproductos');

                var controller = "changeOrdenAlfabeticoBySubproducts";

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };
                var params = {
                    idCategory: this.idCategoryModal,
                    idBusiness: this.idBusiness,
                    tipo: this.idCategoryModal3,
                    jwt: this.$store.getters.jwt
                };

                let vm = this;

                this.axios.post(this.$store.getters.apiUrl + 'categories/' + controller, params, config)
                    .then(function (response) {
                        if (response.data.response) {


                            vm.$notify({
                                message: vm.$t('transferenciaDeProductosEfectuadaCorrectamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            } else {

                swal({
                    title: this.$t('atencion'),
                    text: this.$t('relleneLosCamposObligatorios'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
            }

        },
        openImageModal() {
            this.showButtons = false;
            let config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                },
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.jwt, 
                }
            };
            let vm = this;

            this.axios.get(this.$store.getters.apiUrl + "general/checkImage", config)
                .then(response => {
                    if (response.data.status) {
                        
                        vm.imageUrl = response.data.image_url;
                        // console.log(this.$store.getters.apiUrl);
                        // console.log(response.data.image_url);
                        // console.log(vm.imageUrl);
                        vm.imageInfo = response.data.image_info;
                    } else {
                        vm.imageUrl = null;
                        vm.image = null;
                    }
                })
                .catch(error => {

                });
        },
        closeModal() {
            this.showModal = false;
            this.image = null;
            this.imageInfo = null;
        },
        showReplaceConfirmation() {
            swal.fire({
                position: "center",
                title: this.$t('mensajeconfirmacion'),
                showCloseButton: false,
                reverseButtons: true,
                allowOutsideClick: false,
                showCancelButton: true,
                showConfirmButton: true,
                cancelButtonText: this.$t('botonCancelar'),
                confirmButtonText: this.$t('botonGuardar'),
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33'
            }).then((result) => {
                if (result.value) {
                    this.manageImageActions('save');
                } else if (result.dismiss) {

                } else if (result.dismiss === swal.DismissReason.close) {
                }
            });
        },


        manageImageActions(action = null, event = null) {
            if (action === 'save') {
                if (this.image) {
                    const file = this.image;

                    if (!this.validTypes.includes(file.type)) {
                        swal({
                            title: this.$t('atencion'),
                            text: this.$t('seleccioneArchivoImagen'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                        this.image = null;
                        this.imageUrl = null;
                        return;
                    }

                    if (file.size / 1024 > this.maxSize) {
                        swal({
                            title: this.$t('atencion'),
                            text: this.$t('archivoDemasiadoGrande'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                        this.image = null;
                        this.imageUrl = null;
                        return;
                    }

                    const img = new Image();
                    img.onload = () => {
                        if (img.width > this.maxWidth || img.height > this.maxHeight) {
                            swal({
                                title: this.$t('atencion'),
                                text: this.$t('dimensionesExcedenLimite'),
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                            this.image = null;
                            this.imageUrl = null;
                            return;
                        }
                        if (img.width < this.minWidth || img.height < this.minHeight) {
                            swal({
                                title: this.$t('atencion'),
                                text: this.$t('dimensionesNoSatisfacenMinimo'),
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                            this.image = null;
                            this.imageUrl = null;
                            return;
                        }
                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                jwt: this.$store.getters.jwt
                            },
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.jwt,
                                'Content-Type': 'multipart/form-data'
                            }
                        };

                        const formData = new FormData();
                        formData.append("image", file);



                        let vm = this;
                        this.axios.post(this.$store.getters.apiUrl + "general/saveImage", formData, config)
                            .then(response => {
                                if (response.data.status) {
                                    vm.resetModal();
                                    vm.image = null;
                                    vm.imageUrl = null;
                                    swal({
                                        title: vm.$t('Guardado'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'success'
                                    });
                                } else {
                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message || 'Hubo un error al guardar la Imagen, Vuelva a intentarlo.',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                }
                            })
                            .catch(error => {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: 'Hubo  un error al guardar la imagen. Intenta de nuevo.',
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            });

                    };

                    img.src = URL.createObjectURL(file);

                } else {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('inserteImagen'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                }
            } else if (action === 'back') {
                this.image = null;
                this.imageUrl = null;
                this.imageInfo = null;
                this.openImageModal();

            } else if (event) {
                const file = event.target.files[0];
                if (file) {
                    if (file.type.startsWith("image")) {
                        this.image = file;
                        this.imageUrl = URL.createObjectURL(file);
                        this.showButtons = true;

                        const fileSizeKB = (file.size / (1024)).toFixed(2);

                        const img = new Image();
                        img.onload = () => {
                            this.imageInfo = {
                                width: img.width,
                                height: img.height,
                                size: fileSizeKB
                            };
                        };
                        img.src = this.imageUrl;
                    } else {
                        swal({
                            title: this.$t('atencion'),
                            text: this.$t('seleccioneArchivoImagen'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                        this.image = null;
                        this.imageUrl = null;
                        this.imageInfo = null;
                    }
                }
            }
        },

        //ITERCAMBIAR PRODUCTOS
        /*changeProduct() {

            this.$modal.hide('modalcambiarProduct');

            var controller = "changeProductByCategoryGeneral";

            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
            };
            var params = {
                valores: this.value2,
                listProducto: this.data2,
                idCategory1: this.idCategory1,
                idCategory2: this.idCategory2,
                idBusiness: this.idBusiness,
                jwt: this.$store.getters.jwt
            };

            let vm = this;

            this.axios.post(this.$store.getters.apiUrl + 'categories/' + controller, params, config)
                .then(     (response) {
                    if (response.data.response) {


                        vm.$notify({
                            message: 'Tranferencia de productos efectuada correctamente',
                            icon: 'nc-icon nc-check-2',
                            timeout: 2000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        });


                    }
                    else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });

        },*/
        /*getProductsByCategory() {

            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    idCategory1: this.idCategory1,
                    idCategory2: this.idCategory2,
                    jwt: this.$store.getters.jwt
                },
                headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
            };
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'categories/getProductByCategoryGeneral', config)
                .then(function (response) {
                    if (response.data.response) {

                        vm.value2 = [];
                        vm.data2 = [];

                        const date = [];

                        for (let i = 0; i < response.data.result.length; i++) {

                            if (parseInt(vm.idCategory2) === parseInt(response.data.result[i].idCategory)) {


                                vm.value2.push(
                                    response.data.result[i].idProduct
                                );


                            }
                            date.push({
                                label: response.data.result[i].name,
                                key: response.data.result[i].idProduct,
                                initial: response.data.result[i].name,
                                idCategory: response.data.result[i].idCategory

                            });
                        }

                        vm.data2 = date;


                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });

        },*/

        goToGestionHerramientas() {
        this.$router.push({ name: "herramientas-gestion" });
        },

    },
    computed: {
        ...mapState(["permiso"])
    },
    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
        [Transfer.name]: Transfer,
        [Steps.name]: Steps,
        [Step.name]: Step,
        [ButtonGroup.name]: ButtonGroup
    },
}
</script>

<style scoped>
.card {
  width: 100%;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}

.image-preview-container img {
    max-width: 100%;
    max-height: 500px;
    width: auto;
    height: auto;
    border: 2px solid #ddd;
    border-radius: 8px;
}

.alert-info {
    background-color: transparent;
    color: #0c5460;
    font-size: 14px;
    font-weight: 500;
    border-radius: 5px;
    margin-top: -25px;
    text-align: center;
}


.small {
    font-size: 12px;
    color: #000000;
    font-weight: 400;
    line-height: 1.4;
}

.image-wrapper {
    position: relative;
    text-align: center;
    margin-bottom: 10px;
}

.image-info {
    font-size: 13px;
    color: #363636;
    margin-top: 5px;
    text-align: center;
    padding: 5px 0;
}

.image-info strong {
    font-weight: bold;
}

.image-info p {
    margin: 0;
    font-weight: normal;
}

.close-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 24px;
    font-weight: bold;
    color: white;
    cursor: pointer;
    padding: 0 10px;
    border-radius: 50%;
    transition: background-color 0.3s, color 0.3s;
}

.custom-button {
    background-color: transparent;
    color: rgb(0, 0, 0);
    border: none;
    font-size: 20px;
    padding: 0;
    cursor: pointer;
}

.close-btn {
    font-size: 24px;
    font-weight: bold;
    color: #ff3b3b;
    color: rgb(0, 0, 0);
    cursor: pointer;
    padding: 0 10px;
    border-radius: 50%;
    transition: background-color 0.3s, color 0.3s;
}



.p1 {
    color: red;
}

#error-message {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    border-radius: 5px;
    padding: 15px;
    text-align: center;
    font-size: 16px;
    margin-top: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin: 10px auto;
}

#error-message p {
    margin: 0;
    font-weight: bold;
}

.parrafoDrop {
    list-style: none;
    line-height: 36px;
    padding: 0 20px;
    margin: 0;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    outline: none;
}

.parrafoDrop:hover {

    background-color: #ECF5FF;
}

.wrapperTitleImpresion {
    background-color: #1E22AA;
    ;
    color: white;
    font-weight: bold;
    padding: 5px 15px;
    margin-top: 20px;
}

.wrapperTitle {
    font-size: 28px;
    font-family: 'Roboto', sans-serif;
    padding: 10px 10px;
}

.modal-content {
    background-color: #f8f9fa;
    border-radius: 10px;
}

.image-preview-container img {
    max-width: 100%;
    max-height: 400px;
    border: 2px solid #ddd;
    border-radius: 8px;
}

.btn {
  font-size: 16px;
  padding: 12px 20px;
  white-space: normal;
}

.btn-primary {
    background-color: #007bff;
    border-color: #007bff;
}

.btn-secundary {
    background-color: #474747;
    border-color: #474747;
}

.btn-danger {
    background-color: #dc3545;
    border-color: #dc3545;
}

.info-box {
    background-color: #f1f1f1;
    border: 1px solid #ddd;
    border-radius: 8px;
}

.info-box h5 {
    color: #495057;
    margin-bottom: 10px;
}

.form-group {
    position: relative;
    text-align: center;
    margin-bottom: 1rem;
}

.label-upload {
    font-size: 16px;
    color: #495057;
}

.custom-file-upload {
    display: inline-block;
    position: relative;
}

.custom-file-upload input[type="file"] {
    display: none;
}

.custom-btn {
    font-size: 14px;
    font-weight: 600;
    padding: 12px 25px;
    background-color: #1E22AA;
    border: 2px solid #1E22AA;
    border-radius: 5px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}

.custom-btn:hover {
    background-color: #1E22AA;
    color: #fff;
    transform: scale(1.03);

}

.custom-file-upload input[type="file"]:focus+.custom-btn {
    border-color: #0056b3;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.custom-btn {
    display: inline-block;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    transition: all 0.3s ease;
}

.card {
  border-radius: 10px;
}

.btn-group-vertical .btn {
  font-size: 16px;
  padding: 15px 20px;
  white-space: normal; /* permite texto en varias líneas */
}

.opciones-list {
  border-top: 1px solid #e0e0e0;
  margin-top: 10px;
}

.opcion-card {
  padding: 18px 20px 10px 20px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  background: #fff;
  transition: background 0.15s;
}

.opcion-card:last-child {
  border-bottom: none;
}

.opcion-card:hover {
  background: #f5f7fa;
}

.opcion-title {
  font-size: 18px;
  font-weight: 500;
  color: #1E22AA;
}

.opcion-desc {
  font-size: 14px;
  color: #6c757d;
  margin-top: 4px;
}

.list-files {
  padding: 0;
  margin-bottom: 0px;
  border-top: 2px solid #00A3AD; /* línea superior azul */
}

.list-files li {
  list-style: none;
  padding: 15px 20px;
  font-size: 1.1em;
  border-top: 1px solid #e0e0e0; /* línea gris entre elementos */
  color: #252422;
  cursor: pointer;
  background: #fff;
  transition: background 0.15s;
}

.list-files li:first-child {
  border-top: none;
}

.list-files li:hover {
  background-color: rgba(0, 153, 130, 0.08);
}

.list-files .opcion-title {
  font-size: 18px;
  font-weight: 500;
  color: #1E22AA;
  margin-bottom: 2px;
  display: block;
}

.list-files .opcion-desc {
  font-size: 14px;
  color: #6c757d;
  margin-top: 2px;
  display: block;
}

.ajustes-card {
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.titulo-negocio {
  font-size: 20px;
  font-weight: bold;
  color: #1E22AA;
  margin-bottom: 8px;
  display: block;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Herramientas/Herramientas.vue